import { render, staticRenderFns } from "./achievementawardbase.vue?vue&type=template&id=2ff16606&scoped=true&"
import script from "./achievementawardbase.vue?vue&type=script&lang=ts&"
export * from "./achievementawardbase.vue?vue&type=script&lang=ts&"
import style0 from "./achievementawardbase.vue?vue&type=style&index=0&id=2ff16606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff16606",
  null
  
)

export default component.exports